import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import Title from '../../../components/Headers/Title';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { LicenseProps } from '../../../types/IdProps';
import DataService from "../../../services/data.service";
import { useNotifications } from '../../../contexts/notificationContext';
import AddBusinessPartnerGroupPopup from '../Popups/License_popup_AddBusinessPartnerGroup';
import AddBusinessPartnerPopup from '../Popups/License_popup_AddBusinessPartner';

const License_tab_BusinessPartners: React.FC<LicenseProps> = ({ licenseId }) => {
    const [includedBusinessPartnerGroupData, setIncludedBusinessPartnerGroupData] = useState<any[]>();
    const [excludedBusinessPartnerGroupData, setExcludedBusinessPartnerGroupData] = useState<any[]>();
    const [includedBusinessPartnerData, setIncludedBusinessPartnerData] = useState<any[]>();
    const [excludedBusinessPartnerData, setExcludedBusinessPartnerData] = useState<any[]>();
    const [includedBusinessPartnerGroup, setIncludedBusinessPartnerGroup] = useState<boolean>(false)
    const [includedBusinessPartner, setIncludedBusinessPartner] = useState<boolean>(false)
    const [showBusinessPartnerGroupPopup, setShowBusinessPartnerGroupPopup] = useState<boolean>(false)
    const [showBusinessPartnerPopup, setShowBusinessPartnerPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getBusinessPartnerGroupTableData();
        getBusinessPartnerTableData();
    }, [licenseId]);

    function getBusinessPartnerGroupTableData() {
        DataService.get<any[]>('api/v1/LicenseBusinessPartnerGroups/ByLicenseIncluded/' + licenseId)
            .then(response => {
                setIncludedBusinessPartnerGroupData(response);
            })
            .catch(e => { handleException(e); });

        DataService.get<any[]>('api/v1/LicenseBusinessPartnerGroups/ByLicenseExcluded/' + licenseId)
            .then(response => {
                setExcludedBusinessPartnerGroupData(response);
            })
            .catch(e => { handleException(e); });

    }

    function getBusinessPartnerTableData() {
        DataService.get<any[]>('api/v1/LicenseBusinessPartners/ByLicenseIncluded/' + licenseId)
            .then(response => {
                setIncludedBusinessPartnerData(response);
            })
            .catch(e => { handleException(e); });

        DataService.get<any[]>('api/v1/LicenseBusinessPartners/ByLicenseExcluded/' + licenseId)
            .then(response => {
                setExcludedBusinessPartnerData(response);
            })
            .catch(e => { handleException(e); });

    }

    function deleteBusinessPartnerGroupRow(rowData) {
        DataService.delete('api/v1/LicenseBusinessPartnerGroups/', rowData.id)
            .then(response => {
                handleResult(response);
                getBusinessPartnerGroupTableData();
            })
            .catch(e => { handleException(e); });
    }

    function deleteBusinessPartnerRow(rowData) {
        DataService.delete('api/v1/LicenseBusinessPartners/', rowData.id)
            .then(response => {
                handleResult(response);
                getBusinessPartnerTableData();
            })
            .catch(e => { handleException(e); });
    }

    const includedBusinessPartnerGroupInfos: IColInfo[] = [
        { key: true, dataProp: 'businessPartnerGroupId', visible: false },
        { title: 'Business-partner group', dataProp: 'businessPartnerGroupName', sort: 'asc' },
    ];

    const excludedBusinessPartnerGroupInfos: IColInfo[] = [
        { key: true, dataProp: 'businessPartnerGroupId', visible: false },
        { title: 'Business-partner group', dataProp: 'businessPartnerGroupName', sort: 'asc' },
    ];

    const includedBusinessPartnerInfos: IColInfo[] = [
        { key: true, dataProp: 'businessPartnerId', visible: false },
        { dataProp: 'thumbnailUrl', dataType: 'image' },
        { title: 'Business-partner', dataProp: 'businessPartnerName', sort: 'asc' },
    ];

    const excludedBusinessPartnerInfos: IColInfo[] = [
        { key: true, dataProp: 'businessPartnerId', visible: false },
        { dataProp: 'thumbnailUrl', dataType: 'image' },
        { title: 'Business-partner', dataProp: 'businessPartnerName', sort: 'asc' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.UpdateLicense)) {
        includedBusinessPartnerGroupInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncludedBusinessPartnerGroup(true); setShowBusinessPartnerGroupPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteBusinessPartnerGroupRow }]
            });

        excludedBusinessPartnerGroupInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncludedBusinessPartnerGroup(false); setShowBusinessPartnerGroupPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteBusinessPartnerGroupRow }]
            });

        includedBusinessPartnerInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncludedBusinessPartner(true); setShowBusinessPartnerPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteBusinessPartnerRow }]
            });

        excludedBusinessPartnerInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncludedBusinessPartner(false); setShowBusinessPartnerPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteBusinessPartnerRow }]
            });
    }

    return (
        <Container fluid>
            <Row>
                <Col md='6'>
                    <Title size={4} text='Included' />
                    <Row>
                        <Col md='6'>
                            <DataTable
                                name='dtLicenseIncludedBusinessPartnerGroups'
                                colInfos={includedBusinessPartnerGroupInfos}
                                tableData={includedBusinessPartnerGroupData}
                                navigateTitle={'Business-partner group'}
                                navigateUrl={'/plm/BusinessPartners/BusinessPartnerGroup/'}
                            />
                        </Col>
                        <Col md='6'>
                            <DataTable
                                name='dtLicenseIncludedBusinessPartners'
                                colInfos={includedBusinessPartnerInfos}
                                tableData={includedBusinessPartnerData}
                                navigateTitle={'Business-partner'}
                                navigateUrl={'/plm/BusinessPartners/Details/'}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col md='6'>
                    <Title size={4} text='Excluded' />
                    <Row>
                        <Col md='6'>
                            <DataTable
                                name='dtLicenseExcludedBusinessPartnerGroups'
                                colInfos={excludedBusinessPartnerGroupInfos}
                                tableData={excludedBusinessPartnerGroupData}
                                navigateTitle={'Business-partner group'}
                                navigateUrl={'/plm/BusinessPartners/BusinessPartnerGroup/'}
                            />
                        </Col>
                        <Col md='6'>
                            <DataTable
                                name='dtLicenseExcludedBusinessPartners'
                                colInfos={excludedBusinessPartnerInfos}
                                tableData={excludedBusinessPartnerData}
                                navigateTitle={'Business-partner'}
                                navigateUrl={'/plm/BusinessPartners/Details/'}
                            />
                        </Col>
                    </Row>
                </Col>
            </Row>
            {showBusinessPartnerGroupPopup && <AddBusinessPartnerGroupPopup licenseId={licenseId} included={includedBusinessPartnerGroup} show={showBusinessPartnerGroupPopup} onHide={() => { setShowBusinessPartnerGroupPopup(false); getBusinessPartnerGroupTableData(); }} />}
            {showBusinessPartnerPopup && <AddBusinessPartnerPopup licenseId={licenseId} included={includedBusinessPartner} show={showBusinessPartnerPopup} onHide={() => { setShowBusinessPartnerPopup(false); getBusinessPartnerTableData(); }} />}
        </Container>
    );
}
export default License_tab_BusinessPartners;